/**
 * PDP cross-sell slider powered by Shopify's native product recommendations.
 */
(() => {
  const SELECTOR = '[data-recommendations-slider]';
  const PLACEHOLDER = '[data-recommendations-slider-placeholder]';
  const SCROLL_STEP = 240;

  const reinitLazyImages = () => {
    window.ORW?.lazyload?.update?.();
  };

  const initScrolling = (container) => {
    const track = container.querySelector('.products-wrapper');
    if (!track) return;

    let isDown = false;
    let startX = 0;
    let startScroll = 0;

    track.addEventListener('mousedown', (event) => {
      isDown = true;
      startX = event.pageX - track.offsetLeft;
      startScroll = track.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach((type) =>
      track.addEventListener(type, () => {
        isDown = false;
        track.classList.remove('active');
      })
    );
    track.addEventListener('mousemove', (event) => {
      if (!isDown) return;
      event.preventDefault();
      const walk = event.pageX - track.offsetLeft - startX;
      track.scrollLeft = startScroll - walk;
      if (walk > 12 || walk < -12) track.classList.add('active');
    });

    const left = container.querySelector('.scroll-left');
    const right = container.querySelector('.scroll-right');

    const updateLimits = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      left?.classList.toggle('limit', track.scrollLeft <= 1);
      right?.classList.toggle('limit', track.scrollLeft >= maxScroll - 1);
    };

    left?.addEventListener('click', () => {
      track.scrollLeft -= SCROLL_STEP;
    });
    right?.addEventListener('click', () => {
      track.scrollLeft += SCROLL_STEP;
    });
    track.addEventListener('scroll', updateLimits, { passive: true });
    updateLimits();
  };

  const activate = (container) => {
    reinitLazyImages();
    initScrolling(container);
  };

  const load = (container) => {
    if (!container.querySelector(PLACEHOLDER)) {
      activate(container);
      return;
    }

    const { endpoint, sectionId, productId, limit, intent } = container.dataset;
    if (!endpoint || !sectionId || !productId) return;

    const url = `${endpoint}?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(
      productId
    )}&limit=${encodeURIComponent(limit)}&intent=${encodeURIComponent(intent)}`;

    console.log('url', url);

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
        return response.text();
      })
      .then((html) => {
        const parsed = document.createElement('div');
        parsed.innerHTML = html;

        const rendered = parsed.querySelector(SELECTOR);
        if (!rendered || !rendered.innerHTML.trim().length) {
          container.innerHTML = '';
          return;
        }

        container.innerHTML = rendered.innerHTML;
        activate(container);
      })
      .catch((error) => {
        console.error('[Recommendations Slider]', error);
        container.innerHTML = '';
      });
  };

  const loadAll = () => document.querySelectorAll(SELECTOR).forEach(load);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAll);
  } else {
    loadAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.(SELECTOR).forEach(load);
  });
})();
